import React, { useState } from 'react';
import './Dashboard.css'; // Reuse dashboard styles for layout

const videos = [
  {
    title: 'Chromius Training - CEO - 1',
    desc: 'How to set up your white-labeled extensions',
    youtubeId: 'gIPhYrz4pbI',
  },
  {
    title: 'Chromius Training - CEO - 2',
    desc: 'Building your own custom Google Chrome extension',
    youtubeId: 'dQw4w9WgXcQ', // Replace with real video IDs
  },
  {
    title: 'Chromius Training - CEO - 3',
            desc: 'Sending broadcast messages to your extension end users',
    youtubeId: 'dQw4w9WgXcQ',
  },
  {
    title: 'Chromius Training - CEO - 4',
    desc: 'Creating Partners Manually',
    youtubeId: 'dQw4w9WgXcQ',
  },
  {
    title: 'Chromius Training - CEO - 5',
            desc: 'Create/manage extension end users manually',
    youtubeId: 'dQw4w9WgXcQ',
  },
  {
    title: 'Chromius Training - CEO - 6',
    desc: 'API USER management',
    youtubeId: 'dQw4w9WgXcQ',
  },
  {
    title: 'Chromius Training - CEO - 7',
    desc: 'Partner Management with our API',
    youtubeId: 'dQw4w9WgXcQ',
  },
];

export default function TrainingVideos() {
  const [selected, setSelected] = useState(0);
  const selectedVideo = videos[selected];

  return (
    <div className="trainingContainer d-flex" style={{ minHeight: '60vh', marginTop: 40 }}>
      <div className="headerSection" style={{ minWidth: 300 }}>
        <h2>Training Videos
          <span className="inlineFig">
            <svg xmlns="http://www.w3.org/2000/svg" width="13.132" height="5.836" viewBox="0 0 13.132 5.836">
              <path d="M13.132,514.848a.249.249,0,0,1-.076.182l-2.918,2.69a.237.237,0,0,1-.266.046.229.229,0,0,1-.144-.22v-1.7H.243A.234.234,0,0,1,0,515.6v-1.459a.234.234,0,0,1,.243-.243H9.727v-1.7a.22.22,0,0,1,.144-.22.244.244,0,0,1,.266.038l2.918,2.66A.24.24,0,0,1,13.132,514.848Z" transform="translate(0 -511.952)" />
            </svg>
          </span>
        </h2>
        <p>Get to know your Chromius dashboard a little better.</p>
      </div>
      <div className="trainKyubi d-flex" style={{ flex: 1, gap: 32 }}>
        <div className="traningScreen" style={{ flex: 2 }}>
          <iframe
            width="100%"
            height="350"
            src={`https://www.youtube.com/embed/${selectedVideo.youtubeId}`}
            title={selectedVideo.title}
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>
        </div>
        <div className="traningList" style={{ flex: 1 }}>
          <ul style={{ listStyle: 'none', padding: 0 }}>
            {videos.map((v, i) => (
              <li
                key={i}
                className={`listTraining${selected === i ? ' activeVideo' : ''}`}
                style={{ 
                  marginBottom: 16, 
                  cursor: 'pointer', 
                  background: selected === i ? '#e3f2fd' : 'transparent', 
                  borderRadius: 6, 
                  padding: 8,
                  border: selected === i ? '1px solid #039BE5' : '1px solid transparent',
                  transition: 'all 0.2s ease'
                }}
                onClick={() => setSelected(i)}
              >
                <figure 
                  className={selected === i ? 'activePlay' : ''} 
                  style={{ 
                    marginRight: 12, 
                    display: 'inline-block', 
                    width: 16, 
                    height: 16, 
                    background: selected === i ? '#039BE5' : '#ccc', 
                    borderRadius: '50%',
                    transition: 'background-color 0.2s ease'
                  }}
                ></figure>
                <div className="textTraining" style={{ display: 'inline-block', verticalAlign: 'top' }}>
                  <h4 style={{ margin: 0, fontSize: 16, color: selected === i ? '#039BE5' : '#333' }}>{v.title}</h4>
                  <span style={{ fontSize: 13, color: selected === i ? '#666' : '#999' }}>{v.desc}</span>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
} 